import React, { Fragment, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { white } from '../theme/colors';
import CloseIcon from '@material-ui/icons/Close';
import themeSizes from '../theme/themeSizes';
import { red } from '@material-ui/core/colors';
import { Portal } from './Portal';

const ModalBackDrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${props => props.backdropzIndex || '1270'};
  background-color: ${props => props.backgroundColor ?'#00000033' : '#2c2f42'};
  opacity:${props => props.backDropOpacity || '0.9'};
  display:none;
 
  ${props =>
    props.showModal &&
    css`
      display: block;
    `};
`;
const ModalContainer = styled.div`
  overflow: hidden;
  overflow-y: auto;
  position: fixed;
  top: 100%;
  right: 0;
  bottom: 0;
   border-radius: 10px;
  left: 0;
  z-index: ${props => props.modalzIndex || '1280'};
  -webkit-overflow-scrolling: touch;
  outline: 0;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  
  ${props =>
    props.showModal &&
    css`
      top: 0;
      /* Center content both ways; margin:auto on the content keeps tall modals scrollable */
      display: flex;
      flex-direction: column;
      padding: 24px 16px;
      box-sizing: border-box;
     
      animation: blowUpModal 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    `};

  ${props =>
    !props.showModal &&
    css`
      animation: blowDownModal 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    `};

  @keyframes blowUpModal {
    0% {
      opacity: 0;
      transform: translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes blowDownModal {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(100px);
    }
  }
`;
const ContentContainer = styled.div`
    margin:auto;
    width:100%;
    flex-shrink:0;
    ${props => props.displayFlex && css`
      min-width:${props => props.modalWidth ? props.modalWidth : '40%'};
    `}
     border-radius: 10px;
    max-width:${props => props.modalWidth ? props.modalWidth : '40%'};
    max-height:${props => props.maxHeight ? props.maxHeight : 'auto'};
    background: ${props => props.background || white};
    box-shadow: ${props => props.noContainerShadow || props.hideBoxShadow ? 'none' : '0px 10px 24px rgba(91, 127, 220, 0.16)'};
    min-height: ${props => props.modalHeight || '185px'};
    padding:28px;
    position:relative;
    ${props => props.withHeader && css`
        padding-top:0;
    `};
    display:flex;
    flex-direction:column;
    overflow-y:${({ overflow }) => overflow || 'auto'};
    @media (max-width: 768px) {
      max-width: calc(100% - 32px) !important;
      width: calc(100% - 32px) !important;
      min-width: unset !important;
      padding: 20px 16px !important;
      margin: auto !important;
    }
`;
const HeaderStyle = styled.div`
    display:flex;
    padding-top:28px;
    box-sizing:border-box;
    position:sticky;
    top:0;
    left:0;
    right:0;
    z-index: 10;
    span{
        flex:1;
        text-align:center;
    }
    span + svg{
        align-content:right;
        cursor: pointer;
        ${props => props.closeIconColor && css`
          color: ${props.closeIconColor};
        `};
    }
    @media (max-width: 768px) {
      padding-top: 12px;
      margin-bottom: 8px;
    }
`;

export const Modal = ({
  withHeader = false,
  title = '',
  children,
  background,
  modalWidth,
  modalHeight,
  top,
  showModal,
  maxHeight,
  closeAction = () => { },
  closeIconColor,
  backgroundColor,
  hideBoxShadow,
  noContainerShadow,
  backDropOpacity,
  displayFlex,
  overflow,
  noExit = false
}) => {
  const [modalState, setModalState] = useState(true);
  const [showBackDrop, setBackDrop] = useState(true)

  let timer;
  const onCloseModal = () => {
    setModalState(false);
    timer = setTimeout(() => {
      closeAction && closeAction();
      setBackDrop(false);
    }, 400);
  };
  // const myEventHandler = (e) => {
  //   if (e.which == 27) {
  //     onCloseModal()
  //   }
  // }
  // useEffect(() => {
  //   if(noExit){
  //     return
  //   } else{
  //     window.addEventListener("keypress", myEventHandler, false);
  //     return () => {
  //       window.removeEventListener("keypress", myEventHandler, false);
  //       clearTimeout(timer)
  //     };
  //   }
  //
  // }, []);
  // "Esc" key modal close
  useEffect(() => {
    if(noExit){
      return
    } else{
      const close = (e) => {
        if(e.key === 'Escape'){
          onCloseModal()
        }
      }
      window.addEventListener('keydown',close)
      return () => window.removeEventListener('keydown',close)
    }
  })
  return (
    <Portal>
      <ModalContainer showModal={modalState} displayFlex={displayFlex} background={background}>
        <ContentContainer
          withHeader={withHeader}
          hideBoxShadow={hideBoxShadow}
          maxHeight={maxHeight}
          modalWidth={modalWidth}
          modalHeight={modalHeight}
          top={top}
          background={background}
          noContainerShadow={noContainerShadow}
          displayFlex={displayFlex}
          overflow={overflow}
        >
          {withHeader ?
            <HeaderStyle closeIconColor={closeIconColor}>
              <span>{title ? title : ''}</span>
              {
                noExit ? "" :  <CloseIcon onClick={onCloseModal} style={{ cursor: 'pointer' }} />
              }

            </HeaderStyle>
            : null}
          {children}
        </ContentContainer>
      </ModalContainer>
      <ModalBackDrop showModal={showBackDrop} backDropOpacity={backDropOpacity} backgroundColor={backgroundColor} />
    </Portal>
  )
}
